/**
 * Tujuan lanjutan setelah login (parameter `next`).
 *
 * Situs marketing menautkan langsung ke fitur di dalam app. Rute-rute itu terlindungi,
 * jadi pengguna yang belum login dilempar ke /login dengan `?next=<tujuan>`; nilai itu
 * dipakai lagi setelah autentikasi berhasil.
 *
 * Nilai `next` datang dari URL, artinya bisa diisi siapa saja. Hanya path relatif
 * satu-garis-miring yang diterima — URL absolut dan bentuk protokol-relatif (`//host`)
 * ditolak supaya halaman login tidak bisa dipakai sebagai open redirect ke domain lain.
 */

export const DEFAULT_POST_LOGIN_PATH = '/dashboard';

export function resolveNextPath(
  rawNext: string | null | undefined,
  fallback: string = DEFAULT_POST_LOGIN_PATH
): string {
  if (!rawNext) return fallback;

  let candidate = rawNext;
  // Nilai bisa ter-encode lebih dari sekali kalau dilempar antar redirect.
  for (let i = 0; i < 3 && /%[0-9a-fA-F]{2}/.test(candidate); i++) {
    try {
      const decoded = decodeURIComponent(candidate);
      if (decoded === candidate) break;
      candidate = decoded;
    } catch {
      return fallback;
    }
  }

  candidate = candidate.trim();
  if (!candidate.startsWith('/')) return fallback;      // absolut atau relatif-tak-berakar
  if (candidate.startsWith('//')) return fallback;      // protokol-relatif → host lain
  if (candidate.startsWith('/\\')) return fallback;     // varian backslash yang diterima sebagian browser
  // Spasi dan karakter kontrol bisa dipakai menyelundupkan skema/header. Tanda hubung SAH
  // — banyak rute memakainya (mis. /tier-comparison).
  if (/[\s\u0000-\u001f]/.test(candidate)) return fallback;
  if (/^\/+(javascript|data|vbscript):/i.test(candidate)) return fallback;

  return candidate;
}
